import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as i}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const c=t("costa_rica",i`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19116_3152)">
                <rect
                    width="24"
                    height="16"
                    transform="translate(0 4.5)"
                    fill="#FF4E4E" />
                <path
                    d="M0.000976562 4.49902L24.001 4.49902L24.001 20.499L0.000976562 20.499L0.000976562 4.49902Z"
                    fill="#001489" />
                <path
                    d="M0.000976562 7.16602L24.001 7.16602V17.8325L0.000976562 17.8325L0.000976562 7.16602Z"
                    fill="white" />
                <path
                    d="M0.000976562 9.83203L24.001 9.83203V15.1656L0.000976562 15.1656L0.000976562 9.83203Z"
                    fill="#DA291C" />
            </g>
            <defs>
                <clipPath id="clip0_19116_3152">
                    <rect
                        width="24"
                        height="16"
                        fill="white"
                        transform="translate(0 4.5)" />
                </clipPath>
            </defs>
        </svg>
    `),l=i`
    <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        static>
        <mask
            id="mask0_19116_3151"
            style="mask-type:alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="25">
            <circle
                cx="12"
                cy="12.5"
                r="12"
                fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_19116_3151)">
            <g clip-path="url(#clip0_19116_3151)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M0.000976562 0.5L24.001 0.5L24.001 24.5L0.000976562 24.5L0.000976562 0.5Z"
                    fill="#001489" />
                <path
                    d="M0.000976562 4.5L24.001 4.5L24.001 20.4997L0.000976562 20.4997L0.000976562 4.5Z"
                    fill="white" />
                <path
                    d="M0.000976562 8.5L24.001 8.5V16.5003L0.000976562 16.5003L0.000976562 8.5Z"
                    fill="#DA291C" />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_19116_3151">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="white" />
            </clipPath>
        </defs>
    </svg>
`,r=t("costa_rica_rounded",l),o=t("CR",l);export{o as CR,c as CostaRica,r as CostaRicaRounded};
